import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaCardDirective} from 'angular-awesome';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-architecture',
	templateUrl:'./ArchitecturePage.html',
	styles: [],
	styleUrls:['./ArchitecturePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
		WaCardDirective,
		RouterModule,
		WaButtonDirective,
],
	standalone:true
})
export class ArchitecturePage
{
	mdContent_2 = `\`\`\`mermaid
%%{init: {
  'theme': 'dark',
  'themeVariables': {
    'darkMode': true,
    'background': '#1a1a2e',
    'primaryColor': '#6366f1',
    'primaryTextColor': '#e2e8f0',
    'primaryBorderColor': '#818cf8',
    'secondaryColor': '#1e293b',
    'secondaryTextColor': '#cbd5e1',
    'secondaryBorderColor': '#475569',
    'tertiaryColor': '#0f172a',
    'tertiaryTextColor': '#94a3b8',
    'tertiaryBorderColor': '#334155',
    'lineColor': '#818cf8',
    'textColor': '#e2e8f0',
    'mainBkg': '#1e293b',
    'nodeBorder': '#818cf8',
    'clusterBkg': '#0f172a',
    'clusterBorder': '#475569',
    'titleColor': '#e2e8f0',
    'edgeLabelBackground': '#1e293b',
    'nodeTextColor': '#e2e8f0',
    'actorTextColor': '#e2e8f0',
    'actorBorder': '#818cf8',
    'actorBkg': '#1e293b',
    'actorLineColor': '#818cf8',
    'signalColor': '#818cf8',
    'signalTextColor': '#e2e8f0',
    'labelBoxBkgColor': '#1e293b',
    'labelBoxBorderColor': '#475569',
    'labelTextColor': '#e2e8f0',
    'loopTextColor': '#cbd5e1',
    'noteBkgColor': '#1e293b',
    'noteBorderColor': '#6366f1',
    'noteTextColor': '#e2e8f0',
    'activationBorderColor': '#818cf8',
    'activationBkgColor': '#1e293b',
    'sequenceNumberColor': '#1a1a2e',
    'sectionBkgColor': '#1e293b',
    'altSectionBkgColor': '#0f172a',
    'gridColor': '#334155',
    'taskBorderColor': '#818cf8',
    'taskBkgColor': '#1e293b',
    'taskTextColor': '#e2e8f0',
    'activeTaskBorderColor': '#a5b4fc',
    'activeTaskBkgColor': '#312e81',
    'doneTaskBkgColor': '#475569',
    'doneTaskBorderColor': '#64748b',
    'critBorderColor': '#f87171',
    'critBkgColor': '#7f1d1d',
    'fontFamily': 'Inter, system-ui, sans-serif',
    'fontSize': '14px'
  }
}}%%
graph LR
  APP["🚀 Your App<br/><i>@NgComponent, @NgRoutable</i>"]
  PLUGINS["🧩 Plugins<br/><i>WebAwesome, AG Grid, Charts</i>"]
  CORE["⚙️ JWebMP Core<br/><i>HTML/CSS/JS, Angular Gen</i>"]
  FOUNDATION["🏗️ GuicedEE<br/><i>Guice DI, SPI, Vert.x 5</i>"]

  APP ==> PLUGINS ==> CORE ==> FOUNDATION

  style APP fill:#312e81,stroke:#818cf8,stroke-width:2px,color:#e2e8f0
  style PLUGINS fill:#1e3a5f,stroke:#60a5fa,stroke-width:2px,color:#e2e8f0
  style CORE fill:#1a3330,stroke:#34d399,stroke-width:2px,color:#e2e8f0
  style FOUNDATION fill:#3b1a1a,stroke:#f87171,stroke-width:2px,color:#e2e8f0

\`\`\``;
	mdContent_3 = `\`\`\`mermaid
%%{init: {
  'theme': 'dark',
  'themeVariables': {
    'darkMode': true,
    'background': '#1a1a2e',
    'primaryColor': '#6366f1',
    'primaryTextColor': '#e2e8f0',
    'primaryBorderColor': '#818cf8',
    'secondaryColor': '#1e293b',
    'secondaryTextColor': '#cbd5e1',
    'secondaryBorderColor': '#475569',
    'tertiaryColor': '#0f172a',
    'tertiaryTextColor': '#94a3b8',
    'tertiaryBorderColor': '#334155',
    'lineColor': '#818cf8',
    'textColor': '#e2e8f0',
    'mainBkg': '#1e293b',
    'nodeBorder': '#818cf8',
    'clusterBkg': '#0f172a',
    'clusterBorder': '#475569',
    'titleColor': '#e2e8f0',
    'edgeLabelBackground': '#1e293b',
    'nodeTextColor': '#e2e8f0',
    'actorTextColor': '#e2e8f0',
    'actorBorder': '#818cf8',
    'actorBkg': '#1e293b',
    'actorLineColor': '#818cf8',
    'signalColor': '#818cf8',
    'signalTextColor': '#e2e8f0',
    'labelBoxBkgColor': '#1e293b',
    'labelBoxBorderColor': '#475569',
    'labelTextColor': '#e2e8f0',
    'loopTextColor': '#cbd5e1',
    'noteBkgColor': '#1e293b',
    'noteBorderColor': '#6366f1',
    'noteTextColor': '#e2e8f0',
    'activationBorderColor': '#818cf8',
    'activationBkgColor': '#1e293b',
    'sequenceNumberColor': '#1a1a2e',
    'sectionBkgColor': '#1e293b',
    'altSectionBkgColor': '#0f172a',
    'gridColor': '#334155',
    'taskBorderColor': '#818cf8',
    'taskBkgColor': '#1e293b',
    'taskTextColor': '#e2e8f0',
    'activeTaskBorderColor': '#a5b4fc',
    'activeTaskBkgColor': '#312e81',
    'doneTaskBkgColor': '#475569',
    'doneTaskBorderColor': '#64748b',
    'critBorderColor': '#f87171',
    'critBkgColor': '#7f1d1d',
    'fontFamily': 'Inter, system-ui, sans-serif',
    'fontSize': '14px'
  }
}}%%
graph LR
  subgraph APP["YOUR APPLICATION"]
    a1["@NgComponent<br/>@NgRoutable<br/>@NgDataService"]
  end
  subgraph PLUGINS["PLUGINS"]
    p1["WebAwesome · AG Grid<br/>Charts · RabbitMQ<br/>Font Awesome · Calendar"]
  end
  subgraph CORE["JWEBMP CORE"]
    c1["HTML Elements · CSS Builder<br/>Events · AJAX Pipeline<br/>Angular Generator · TS Compiler"]
  end
  subgraph FOUNDATION["GUICEDEE"]
    f1["Guice DI · SPI Discovery<br/>JPMS · Vert.x 5 HTTP<br/>Event Bus · Call Scopes"]
  end
  APP ==> PLUGINS ==> CORE ==> FOUNDATION

  style APP fill:#312e81,stroke:#818cf8,stroke-width:2px,color:#e2e8f0
  style PLUGINS fill:#1e3a5f,stroke:#60a5fa,stroke-width:2px,color:#e2e8f0
  style CORE fill:#1a3330,stroke:#34d399,stroke-width:2px,color:#e2e8f0
  style FOUNDATION fill:#3b1a1a,stroke:#f87171,stroke-width:2px,color:#e2e8f0

\`\`\``;
	mdContent_4 = `At build time, the Angular Maven Plugin scans your classpath for \`@NgApp\`-annotated classes. It invokes the TypeScript Compiler which walks every \`@NgComponent\`, \`@NgDirective\`, \`@NgDataService\`, and \`@NgRoutable\` class. For each, it generates a \`.ts\` file, registers it in the Angular module, and adds its route to the router config. The result is a complete Angular 21 project that the Angular CLI builds into a production \`dist/\` directory.`;
	mdContent_5 = `\`\`\`mermaid
%%{init: {
  'theme': 'dark',
  'themeVariables': {
    'darkMode': true,
    'background': '#1a1a2e',
    'primaryColor': '#6366f1',
    'primaryTextColor': '#e2e8f0',
    'primaryBorderColor': '#818cf8',
    'secondaryColor': '#1e293b',
    'secondaryTextColor': '#cbd5e1',
    'secondaryBorderColor': '#475569',
    'tertiaryColor': '#0f172a',
    'tertiaryTextColor': '#94a3b8',
    'tertiaryBorderColor': '#334155',
    'lineColor': '#818cf8',
    'textColor': '#e2e8f0',
    'mainBkg': '#1e293b',
    'nodeBorder': '#818cf8',
    'clusterBkg': '#0f172a',
    'clusterBorder': '#475569',
    'titleColor': '#e2e8f0',
    'edgeLabelBackground': '#1e293b',
    'nodeTextColor': '#e2e8f0',
    'actorTextColor': '#e2e8f0',
    'actorBorder': '#818cf8',
    'actorBkg': '#1e293b',
    'actorLineColor': '#818cf8',
    'signalColor': '#818cf8',
    'signalTextColor': '#e2e8f0',
    'labelBoxBkgColor': '#1e293b',
    'labelBoxBorderColor': '#475569',
    'labelTextColor': '#e2e8f0',
    'loopTextColor': '#cbd5e1',
    'noteBkgColor': '#1e293b',
    'noteBorderColor': '#6366f1',
    'noteTextColor': '#e2e8f0',
    'activationBorderColor': '#818cf8',
    'activationBkgColor': '#1e293b',
    'sequenceNumberColor': '#1a1a2e',
    'sectionBkgColor': '#1e293b',
    'altSectionBkgColor': '#0f172a',
    'gridColor': '#334155',
    'taskBorderColor': '#818cf8',
    'taskBkgColor': '#1e293b',
    'taskTextColor': '#e2e8f0',
    'activeTaskBorderColor': '#a5b4fc',
    'activeTaskBkgColor': '#312e81',
    'doneTaskBkgColor': '#475569',
    'doneTaskBorderColor': '#64748b',
    'critBorderColor': '#f87171',
    'critBkgColor': '#7f1d1d',
    'fontFamily': 'Inter, system-ui, sans-serif',
    'fontSize': '14px'
  }
}}%%
graph LR
  MVN["mvn install"] --> COMPILE["javac"]
  COMPILE --> PLUGIN["Angular Maven Plugin"]

  subgraph CODEGEN["Code Generation"]
    direction TB
    DISCOVER["Discover @NgApp"]
    TSCOMPILE["Generate .ts files"]
    MODPROC["Build module tree"]
    COMPPROC["Emit components"]
    DISCOVER --> TSCOMPILE --> MODPROC --> COMPPROC
  end

  subgraph SCAFFOLD["Project Scaffold"]
    direction TB
    DEPMGR["Write package.json"]
    APPSETUP["Write angular.json"]
  end

  PLUGIN --> CODEGEN
  PLUGIN --> SCAFFOLD
  CODEGEN --> NGBUILD["ng build --prod"]
  SCAFFOLD --> NGBUILD
  NGBUILD --> PACKAGE["dist/ → JAR"]

  style CODEGEN fill:#1e3a5f,stroke:#60a5fa,stroke-width:2px,color:#e2e8f0
  style SCAFFOLD fill:#1a3330,stroke:#34d399,stroke-width:2px,color:#e2e8f0
  style PACKAGE fill:#312e81,stroke:#818cf8,stroke-width:2px,color:#e2e8f0

\`\`\``;
	mdContent_6 = `\`\`\`mermaid
%%{init: {
  'theme': 'dark',
  'themeVariables': {
    'darkMode': true,
    'background': '#1a1a2e',
    'primaryColor': '#6366f1',
    'primaryTextColor': '#e2e8f0',
    'primaryBorderColor': '#818cf8',
    'secondaryColor': '#1e293b',
    'secondaryTextColor': '#cbd5e1',
    'secondaryBorderColor': '#475569',
    'tertiaryColor': '#0f172a',
    'tertiaryTextColor': '#94a3b8',
    'tertiaryBorderColor': '#334155',
    'lineColor': '#818cf8',
    'textColor': '#e2e8f0',
    'mainBkg': '#1e293b',
    'nodeBorder': '#818cf8',
    'clusterBkg': '#0f172a',
    'clusterBorder': '#475569',
    'titleColor': '#e2e8f0',
    'edgeLabelBackground': '#1e293b',
    'nodeTextColor': '#e2e8f0',
    'actorTextColor': '#e2e8f0',
    'actorBorder': '#818cf8',
    'actorBkg': '#1e293b',
    'actorLineColor': '#818cf8',
    'signalColor': '#818cf8',
    'signalTextColor': '#e2e8f0',
    'labelBoxBkgColor': '#1e293b',
    'labelBoxBorderColor': '#475569',
    'labelTextColor': '#e2e8f0',
    'loopTextColor': '#cbd5e1',
    'noteBkgColor': '#1e293b',
    'noteBorderColor': '#6366f1',
    'noteTextColor': '#e2e8f0',
    'activationBorderColor': '#818cf8',
    'activationBkgColor': '#1e293b',
    'sequenceNumberColor': '#1a1a2e',
    'sectionBkgColor': '#1e293b',
    'altSectionBkgColor': '#0f172a',
    'gridColor': '#334155',
    'taskBorderColor': '#818cf8',
    'taskBkgColor': '#1e293b',
    'taskTextColor': '#e2e8f0',
    'activeTaskBorderColor': '#a5b4fc',
    'activeTaskBkgColor': '#312e81',
    'doneTaskBkgColor': '#475569',
    'doneTaskBorderColor': '#64748b',
    'critBorderColor': '#f87171',
    'critBkgColor': '#7f1d1d',
    'fontFamily': 'Inter, system-ui, sans-serif',
    'fontSize': '14px'
  }
}}%%
sequenceDiagram
  participant B as 🌐 Browser
  participant V as ⚡ Vert.x Server
  participant H as ☕ Java Handler

  rect rgba(99, 102, 241, 0.1)
  Note over B,V: Page Delivery
  B->>V: GET /dashboard
  V-->>B: index.html + dist/ assets
  end

  rect rgba(52, 211, 153, 0.1)
  Note over B,H: AJAX Event Cycle
  B->>V: POST /jwajax
  V->>H: deserialize AjaxCall
  H->>H: intercept → fireEvent()
  H-->>V: AjaxResponse
  V-->>B: DOM update instructions
  end

  rect rgba(248, 113, 113, 0.1)
  Note over B,H: Real-Time Push
  B->>V: WS /eventbus STOMP
  V->>H: RabbitMQ exchange
  V-->>B: STOMP message push
  end

\`\`\``;
	mdContent_7 = `Every JWebMP module declares its dependencies explicitly in \`module-info.java\`. The JPMS module graph ensures clean boundaries — no classpath hell, no hidden dependencies, no runtime surprises.`;
	mdContent_8 = `\`\`\`mermaid
%%{init: {
  'theme': 'dark',
  'themeVariables': {
    'darkMode': true,
    'background': '#1a1a2e',
    'primaryColor': '#6366f1',
    'primaryTextColor': '#e2e8f0',
    'primaryBorderColor': '#818cf8',
    'secondaryColor': '#1e293b',
    'secondaryTextColor': '#cbd5e1',
    'secondaryBorderColor': '#475569',
    'tertiaryColor': '#0f172a',
    'tertiaryTextColor': '#94a3b8',
    'tertiaryBorderColor': '#334155',
    'lineColor': '#818cf8',
    'textColor': '#e2e8f0',
    'mainBkg': '#1e293b',
    'nodeBorder': '#818cf8',
    'clusterBkg': '#0f172a',
    'clusterBorder': '#475569',
    'titleColor': '#e2e8f0',
    'edgeLabelBackground': '#1e293b',
    'nodeTextColor': '#e2e8f0',
    'actorTextColor': '#e2e8f0',
    'actorBorder': '#818cf8',
    'actorBkg': '#1e293b',
    'actorLineColor': '#818cf8',
    'signalColor': '#818cf8',
    'signalTextColor': '#e2e8f0',
    'labelBoxBkgColor': '#1e293b',
    'labelBoxBorderColor': '#475569',
    'labelTextColor': '#e2e8f0',
    'loopTextColor': '#cbd5e1',
    'noteBkgColor': '#1e293b',
    'noteBorderColor': '#6366f1',
    'noteTextColor': '#e2e8f0',
    'activationBorderColor': '#818cf8',
    'activationBkgColor': '#1e293b',
    'sequenceNumberColor': '#1a1a2e',
    'sectionBkgColor': '#1e293b',
    'altSectionBkgColor': '#0f172a',
    'gridColor': '#334155',
    'taskBorderColor': '#818cf8',
    'taskBkgColor': '#1e293b',
    'taskTextColor': '#e2e8f0',
    'activeTaskBorderColor': '#a5b4fc',
    'activeTaskBkgColor': '#312e81',
    'doneTaskBkgColor': '#475569',
    'doneTaskBorderColor': '#64748b',
    'critBorderColor': '#f87171',
    'critBkgColor': '#7f1d1d',
    'fontFamily': 'Inter, system-ui, sans-serif',
    'fontSize': '14px'
  }
}}%%
graph LR
  CORE["com.jwebmp.core"]

  subgraph JWEBMP["JWebMP Layer"]
    CLIENT["com.jwebmp.client"]
  end

  subgraph GUICEDEE["GuicedEE Layer"]
    GUICEE["com.guicedee.client"]
    VERTX["com.guicedee.vertx"]
  end

  subgraph RUNTIME["Runtime"]
    VXC["io.vertx.core"]
    VXW["io.vertx.web"]
    GUICE["com.google.guice"]
    JACKSON["com.fasterxml.jackson"]
  end

  subgraph SPECS["Jakarta Specs"]
    JAKARTA["jakarta.validation"]
    COMMONS["org.apache.commons"]
  end

  CORE ==> CLIENT
  CORE ==> GUICEE
  CORE ==> VERTX
  GUICEE --> GUICE
  VERTX --> VXC
  VERTX --> VXW
  CORE -.-> JACKSON
  CORE -.-> JAKARTA
  CORE -.-> COMMONS

  style JWEBMP fill:#312e81,stroke:#818cf8,stroke-width:2px,color:#e2e8f0
  style GUICEDEE fill:#1e3a5f,stroke:#60a5fa,stroke-width:2px,color:#e2e8f0
  style RUNTIME fill:#1a3330,stroke:#34d399,stroke-width:2px,color:#e2e8f0
  style SPECS fill:#3b1a1a,stroke:#f87171,stroke-width:2px,color:#e2e8f0

\`\`\``;
}
